import React from "react";
import SignupModal from "../components/SignupModal";

const SignUpPage = () => {
  return (
    <div className="signup-page-background">
      <SignupModal show={true} />
    </div>
  );
};

export default SignUpPage; 
